/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class FacebookInput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    error={this.props.error}
                    headerCopy={<span>Post Items <strong>from</strong> this Facebook Page</span>}/>
                <ChooserMain
                    {...this.props}/>
            </div>
        );
    }
}

FacebookInput.displayName = "FacebookInput";

export default FacebookInput;
